import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * Inventory Order class for displaying Job and Location Detail
 */
class InventoryOrderDetailTable extends Component {
    render() {

        const {
            jobDetail
        } = this.props;

        return (
            <div className="report-header-col-container">
                <div className="report-header-col col-6">
                    <table className="report-header-table">
                        <tbody>
                        <tr>
                            <td colSpan={2}><strong>Job</strong></td>
                        </tr>
                        <tr>
                            <td>ID</td>
                            <td>{jobDetail.job_id}</td>
                        </tr>
                        <tr>
                            <td>Name</td>
                            <td>{jobDetail.job_name}</td>
                        </tr>
                        <tr>
                            <td>Created</td>
                            <td>{jobDetail.job_created_str}</td>
                        </tr>
                        <tr>
                            <td>Created by</td>
                            <td>{jobDetail.job_user}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="report-header-col col-6">
                    <table className="report-header-table">
                        <tbody>
                        <tr>
                            <td colSpan={2}><strong>Location</strong></td>
                        </tr>
                        <tr>
                            <td>CloudSent ID</td>
                            <td>{jobDetail.location_id}</td>
                        </tr>
                        <tr>
                            <td>X3 ID</td>
                            <td>{jobDetail.x3_location_id}</td>
                        </tr>
                        <tr>
                            <td>Name</td>
                            <td>{jobDetail.location_name}</td>
                        </tr>
                        <tr>
                            <td>Initial Warehouse</td>
                            <td>{jobDetail.warehouse_initial}</td>
                        </tr>
                        <tr>
                            <td>Restock Warehouse</td>
                            <td>{jobDetail.warehouse_restock}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

InventoryOrderDetailTable.propTypes = {
    jobDetail: PropTypes.object
};

export default InventoryOrderDetailTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryOrderDetailTable.js